import { Dispatch } from "react";

import { useDispatch, useSelector } from "react-redux";
import * as Actions from "../../store/actions";
import BasicAirlineSearchInput from "../../Components/Inputs/BasicAirlineSearchInput";

const AdvancedSearch = ({ open, setOpen, children, dark = false }: any) => {
  const dispatch: Dispatch<any> = useDispatch();

  const includedCarrier = useSelector(
    (state: any) => state.form.includedCarrier
  );

  return (
    <>
      <div className="flex items-center justify-between w-full py-3">
        <div
          onClick={() => {
            setOpen(!open);
          }}
          className={
            dark
              ? "text-xs md:text-sm cursor-pointer flex justify-end text-white/70 hover:text-white underline mt-2"
              : "text-xs md:text-sm cursor-pointer flex justify-end text-[#000046] underline mt-2"
          }
        >
          Advanced Search
        </div>
        {children}
      </div>

      {open && (
        <div>
          <BasicAirlineSearchInput
            name="Select specific airline"
            placeholder="Search..."
            variant={dark ? "dark" : "light"}
            value={includedCarrier}
            onChange={(e: any) => {
              dispatch(Actions.setIncludedAirport(e));
            }}
          />
        </div>
      )}
    </>
  );
};
export default AdvancedSearch;
